import { render, staticRenderFns } from "./contact-phone-number-column.vue?vue&type=template&id=3da9aa48"
import script from "./contact-phone-number-column.vue?vue&type=script&lang=js"
export * from "./contact-phone-number-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da9aa48')) {
      api.createRecord('3da9aa48', component.options)
    } else {
      api.reload('3da9aa48', component.options)
    }
    module.hot.accept("./contact-phone-number-column.vue?vue&type=template&id=3da9aa48", function () {
      api.rerender('3da9aa48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/contact-phone-number-column.vue"
export default component.exports